var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgComponentDark4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 147,
    viewBox: "0 0 131 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9788 4C75.1263 11.0371 50.0419 17.6164 25.9595 27.0709C22.3691 28.4805 18.7502 29.8851 15.3853 31.7706C10.4505 34.5358 15.8952 34.6858 17.7352 34.7613C27.0237 35.1419 36.7721 34.1976 45.933 32.7319C48.2391 32.3629 61.5293 27.1694 55.2254 34.0136C41.5014 48.914 24.6551 62.1475 8.5495 74.3877C-7.79835 86.8121 24.7065 78.0275 30.766 77.058",
    stroke: "#FEFAE0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9788 4C75.1263 11.0371 50.0419 17.6164 25.9595 27.0709C22.3691 28.4805 18.7502 29.8851 15.3853 31.7706C10.4505 34.5358 15.8952 34.6858 17.7352 34.7613C27.0237 35.1419 36.7721 34.1976 45.933 32.7319C48.2391 32.3629 61.5293 27.1694 55.2254 34.0136C41.5014 48.914 24.6551 62.1475 8.5495 74.3877C-7.79835 86.8121 24.7065 78.0275 30.766 77.058",
    stroke: "#FEFAE0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3761 78.9805C29.3536 89.7989 11.2274 123.2 40.3761 123.2",
    stroke: "#FEFAE0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.44 22.9414C101.587 29.9785 76.5029 36.5578 52.4205 46.0123C48.8301 47.4219 45.2112 48.8265 41.8463 50.712C36.9115 53.4772 42.3561 53.6273 44.1961 53.7027C53.4846 54.0833 63.233 53.139 72.3939 51.6733C74.7 51.3043 87.9902 46.1108 81.6864 52.955C67.9623 67.8554 51.1161 81.0889 35.0104 93.3291C18.6626 105.754 51.1674 96.9689 57.2269 95.9994",
    stroke: "#FEFAE0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.44 22.9414C101.587 29.9785 76.5029 36.5578 52.4205 46.0123C48.8301 47.4219 45.2112 48.8265 41.8463 50.712C36.9115 53.4772 42.3561 53.6273 44.1961 53.7027C53.4846 54.0833 63.233 53.139 72.3939 51.6733C74.7 51.3043 87.9902 46.1108 81.6864 52.955C67.9623 67.8554 51.1161 81.0889 35.0104 93.3291C18.6626 105.754 51.1674 96.9689 57.2269 95.9994",
    stroke: "#633E29",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8371 97.9219C55.8145 108.74 37.6884 142.141 66.8371 142.141",
    stroke: "#633E29",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgComponentDark4);
export default __webpack_public_path__ + "static/media/bg_component_dark_4.3546f809532472f66275a4a80454c4e9.svg";
export { ForwardRef as ReactComponent };